export enum CreditLineRequestType {
    Credit = 'credit',
    Prescreening = 'prescreening',
}
